export const usePageMeta = () =>
	useState("page-meta", () => ({
		title: "",
		description: ""
	}));
